/*
 * @Author: huangzq
 * @Date: 2020-02-19 15:08:37
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-03-20 15:37:57
 * @Desc: 海报图片预览
*/
<template>
  <div class="poster-preview">
    <img
      :src="previewData.item.cover"
      alt="cover"
    >
    <div
      v-if="showSize"
      class="size"
    >
      尺寸：{{ previewData.item.canvas.width + previewData.item.canvas.unit }} * {{ previewData.item.canvas.height + previewData.item.canvas.unit }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosterPreview',
  props: {
    previewData: {
      type: Object,
      default () {
        return null
      }
    },
    // 是否显示尺寸
    showSize: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.poster-preview {
  text-align: center;

  img {
    max-height: 504px;
  }

  .size {
    margin-top: 15px;
    font-size: 14px;
    color: #fff;
  }
}
</style>
